export default {
  brand: { name: 'POM', tag: 'Path of Masters', engine: 'POM · PATH OF MASTERS', disclaimer: 'CFDs and leveraged trading carry high risk. Please read all rules carefully.' },
  nav: { overview: 'Overview', leaderboard: 'Leaderboard', route: 'Path', accounts: 'MT5 Accounts', news: 'News', profile: 'Profile', logout: 'Log out' },
  metric: { wallet: 'Wallet', equity: 'Main equity', trades: 'Trades', edge: 'EDGE score' },
  round: { n: 'Round {n}', names: ['', 'Round 1', 'Round 2', 'Round 3', 'Round 4', 'Round 5', 'Round 6'] },
  common: {
    loading: 'Loading…', retry: 'Retry', empty: 'No data', back: 'Back', cancel: 'Cancel', confirm: 'Confirm', save: 'Save',
    prev: 'Prev', next: 'Next', copy: 'Copy', copied: 'Copied', done: 'Completed', submit: 'Submit', mockHint: 'Demo data'
  },
  auth: {
    loginTitle: 'Sign in to Trader Path', loginSub: 'Prove your trading edge and start your path to a million',
    username: 'Username', usernameOrEmail: 'Username or email', email: 'Email', password: 'Password', passwordConfirm: 'Confirm password',
    country: 'Country', selectCountry: 'Select country', code: 'Email code', sendCode: 'Send code', resend: 'Resend in {s}s', refId: 'Referral code (optional)',
    login: 'Sign in', register: 'Sign up', noAccount: 'No account yet?', toRegister: 'Sign up', hasAccount: 'Already have an account?', toLogin: 'Sign in',
    registerTitle: 'Create account', registerSub: 'Sign up to check your Trader Path eligibility',
    codeSent: 'Code sent to your email', registerOk: 'Account created. Please sign in.',
    err: { required: '{field} is required', email: 'Invalid email', mismatch: 'Passwords do not match', minPwd: 'At least 6 characters' }
  },
  accounts: {
    title: 'MT5 Accounts', sub: 'Create and view your MT5 trading accounts',
    create: 'Open MT5 account', createSub: 'Choose an account group and leverage — the account is opened right away', createBtn: 'Open account', created: 'Account created',
    empty: 'You have no MT5 account yet',
    id: 'Account', type: 'Type', currency: 'Currency', balance: 'Balance', credit: 'Credit', leverage: 'Leverage',
    group: 'Account group', selectGroup: 'Select a group', archived: 'Archived',
    tabAccounts: 'Accounts', tabTransfer: 'Transfer', tabRecords: 'Records'
  },
  transfer: {
    sub: 'Move funds between your cash wallet and MT5 accounts',
    in: 'Deposit to MT5', out: 'Withdraw from MT5 to wallet',
    walletBalance: 'Wallet balance', mt5Balance: 'MT5 balance', from: 'From', to: 'To', wallet: 'Cash wallet',
    account: 'MT5 account', amount: 'Amount', secPassword: 'Security password', available: 'Available to withdraw', noAccount: 'No MT5 account available',
    confirmIn: 'Confirm transfer', confirmOut: 'Confirm withdrawal', fillAll: 'Please fill in all fields', doneIn: 'Transfer completed', doneOut: 'Withdrawal submitted'
  },
  records: {
    sub: 'Transfers between your cash wallet and MT5',
    toMt5: 'Deposits to MT5', fromMt5: 'Withdrawals to wallet',
    id: 'ID', detail: 'Detail', amount: 'Amount (USD)', time: 'Time'
  },
  news: {
    title: 'News & Notices', sub: 'Latest platform news and announcements', tabNews: 'News', tabNotice: 'Notices', readMore: 'Read more', unread: 'Unread', total: '{n} items'
  },
  profile: {
    title: 'Profile', sub: 'Manage your personal details and account security',
    info: 'Details', edit: 'Edit profile', security: 'Change password',
    username: 'Username', fullname: 'Full name', email: 'Email', phone: 'Phone', country: 'Country', joined: 'Joined', referrer: 'Referrer',
    oldPassword: 'Current password', newPassword: 'New password', newPasswordConfirm: 'Confirm new password',
    editHint: 'Updating your profile also sets your login password', saved: 'Saved', pwdChanged: 'Password changed'
  },
  overview: {
    welcome: 'Welcome to Trader Path — your road to a million',
    welcomeSub: 'You have joined Trader Path. Prove your skill through trading and start the climb.',
    addFunds: 'Add funds', tradeNow: 'Trade now',
    path: 'Trader Path', pathSub: 'Your road to the next stage.', viewRoute: 'View path',
    joined: 'Joined', passed: 'Passed', target: 'Current target',
    edgeTitle: 'Your EDGE score', edgeBadge: 'AI quant assessment', edgeScore: 'EDGE score', edgeNeed: '{round} needs {n}',
    skill: 'Skill', risk: 'Risk', consistency: 'Consistency', experience: 'Experience', modelVersion: 'Model version: {v}', refresh: 'Refreshed daily 08:00 (UTC+8)',
    qualTitle: '{round} requirements', qualSub: 'Meet all requirements to advance to {round}', qualSubFirst: 'Meet these to enter Round 1', reached: 'met',
    promote: 'Advance to {round}', start: 'Start Trader Path',
    reqTrades: 'Complete {n} independent trades in {round}', reqTradesFirst: 'Complete {n} independent trades', reqEdge: 'EDGE score {n}+', reqEquity: 'Main equity at least {n} USD',
    reqDays: 'Stay {n} days in {round}', reqProfit: 'Profit {n} USD to reach {round}',
    yourTrades: 'Your trades', yourEdge: 'Your EDGE', yourEquity: 'Your equity', yourDays: 'Days so far', yourProfit: 'Your profit', days: 'days',
    funded: 'Funded account', maxLoss: 'Max loss', multiplier: 'Multiplier', share: 'Profit share', viewTrades: 'View trades',
    fundedEquity: 'Funded equity', fundedProfit: 'Net profit', expectedShare: 'Expected payout', closedOrders: 'Closed orders', openOrders: 'Open orders',
    curve: 'Funded P&L', curveSub: 'Cumulative P&L to date', netProfit: 'Net profit ($USD)', riskOn: 'Automated risk monitoring is running',
    confirmStart: 'Start Round 1 of Trader Path now?', confirmPromote: 'Advancing to {round} will close all positions on your funded account. Continue?',
    tradeTitle: 'Start trading!', tradeSub: 'Your MT4 account details and download link.', server: 'Server', login: 'Login', downloadMt4: 'Download MT4',
    pendingApi: 'Trader Path API in progress — showing demo data'
  },
  route: {
    badge: 'TRADER PATH',
    hero1: 'Welcome to Trader Path,', hero2: 'unleash your trading talent', hero3: 'and become a millionaire trader',
    heroSub: 'Six rounds of selection and capital backing — up to a USD 1,000,000 funded account and up to 80% profit share.',
    tableTitle: 'Requirements & benefits', unit: 'Amounts in USD', criteria: 'Criteria',
    minEquity: 'Min. main equity', edge: 'EDGE score', multiplier: 'Multiplier', maxDeposit: 'Max deposit', share: 'Profit share', target: 'Profit target',
    days: 'Duration', trades: 'Trades', leverage: 'Funded leverage', maxLoss: 'Max loss',
    fundedNote: '(funded)', daysNote: '(min. days)', tradesNote: '(min.)',
    rulesTitle: 'Rules & risk control',
    rule1Title: 'Independent trades',
    rule1: 'A trade counts once it is opened and closed with no other open position on the same symbol at the same time. Overlapping orders on one symbol do not count.',
    rule1Foot: 'Based on server execution time',
    rule2Title: 'Payouts & withdrawals',
    rule2: 'Close positions before advancing. Funded profit is paid to your wallet at the previous round\'s share and can be withdrawn on the 1st of next month.',
    rule2Foot: 'Withdrawals open on the 1st',
    rule3Title: 'Elimination & cool-down',
    rule3: 'Hitting max loss, or equity/EDGE below the round standard, eliminates you. Round 1 has no cool-down; otherwise the first two eliminations drop you one round after 14 days, the third restarts you at Round 1.',
    rule3Foot: 'Equity & loss monitored live, EDGE daily'
  },
  leaderboard: {
    title: 'Leaderboard', live: 'Live', top3: 'Top 3 traders', updated: 'As of last month',
    distributed: 'Distributed profit', returnRate: 'Return', equity: 'Main equity', funded: 'Funded size',
    total: 'Overall ranking', totalSub: 'Performance across all rounds', all: 'All', rank: 'Rank', trader: 'Trader', level: 'Round',
    footer: 'Top {n} traders · {total} participants'
  },
  error: {
    NETWORK_ERROR: 'Network error. Please try again.', SERVER_ERROR: 'Server busy. Please try again.', DUPLICATE_REQUEST: 'Too many requests. Please wait.',
    UNAUTHORIZED: 'Session expired. Please sign in again.', LOGIN_FAIL: 'Incorrect username or password', REQUEST_FAILED: 'Request failed',
    // 后端接口返回的 message
    'Account Not found': 'Account not found',
    APPROVED: 'Approved',
    'Bonus settled': 'Bonus already settled',
    'code exist': 'Code already exists',
    'Connection Error': 'Connection error',
    'Deposit Capping': 'Deposit limit reached',
    'Duplicate request detected': 'Duplicate request, please try again later',
    EMAIL_EXITS: 'Email already exists',
    FOLLOWING_TRADE: 'Already following this trade',
    ibo_return_msg: 'ibo_return_msg',
    'Incorrect current password': 'Incorrect current password',
    'incorrect email': 'Incorrect email',
    'Incorrect ID': 'Incorrect ID',
    'Incorrect package': 'Incorrect package',
    'Incorrect Role': 'Incorrect role',
    'Incorrect User': 'Incorrect user',
    'Incorrect user': 'Incorrect user',
    'Incorrect Username': 'Incorrect username',
    INCORRECT_ACTION: 'Incorrect action',
    INCORRECT_ADDRESS: 'Incorrect address',
    INCORRECT_BANK: 'Incorrect bank details',
    INCORRECT_EMAIL_FORMAT: 'Incorrect email format',
    INCORRECT_ID: 'Incorrect ID',
    INCORRECT_OTP: 'Incorrect OTP',
    Incorrect_otp: 'Incorrect OTP',
    INCORRECT_PACKAGE: 'Incorrect package',
    INCORRECT_PASSWORD: 'Incorrect password',
    INCORRECT_SEC_PASSWORD: 'Incorrect security password',
    INCORRECT_SPONSOR: 'Incorrect sponsor',
    INCORRECT_USERNAME: 'Incorrect username',
    INSUFFICIAN_BALANCE: 'Insufficient balance',
    kyc_exist: 'KYC already submitted',
    LAST_DEPOSIT_PENDING: 'Your last deposit is still pending',
    LAST_WITHDRAWAL_PENDING: 'Your last withdrawal is still pending',
    Login_OK: 'Login successful',
    Logout_OK: 'Logout successful',
    MEMBER_EXITS: 'Member already exists',
    'Min withdraw': 'Below minimum withdrawal amount',
    'Mt5 Account not found': 'MT5 account not found',
    'Mt5 Account Update Fail': 'Failed to update MT5 account',
    'Name exist': 'Name already exists',
    NO_PERMISSION: 'No permission',
    OK: 'OK',
    'only can upgrade package': 'You can only upgrade your package',
    OTP_OK: 'OTP verified',
    OTP_sent: 'OTP sent',
    'package not active': 'Package is not active',
    'package terminated': 'Package terminated',
    Password_changed: 'Password changed',
    Password_reset_success: 'Password reset successful',
    PENDING: 'Pending',
    PLEASE_COMPLETE_KYC: 'Please complete KYC',
    Register_successful: 'Registration successful',
    REQUEST_COMPLETE: 'Request completed',
    REQUEST_FAIL: 'Request failed',
    'sponsor not found': 'Sponsor not found',
    Successful: 'Successful',
    suspend_account: 'Account suspended',
    'Updated Successfully': 'Updated successfully',
    'Upload successful': 'Upload successful',
    'User not exist': 'User does not exist',
    'User not found': 'User not found',
    'User Not found': 'User not found',
    'User status is updated': 'User status updated',
    userFreezed: 'Account is frozen',
    'Username already registered': 'Username already registered',
    'Your BO capital is same with package': 'Your BO capital is the same as the package',
    '操作失败': 'Operation failed',
    '操作成功': 'Operation successful',
    '用户不存在': 'User does not exist',
    '钱包不足': 'Insufficient wallet balance'
  }
}
